import { render } from "./LocationsView.vue?vue&type=template&id=e21d7842"
import script from "./LocationsView.vue?vue&type=script&lang=js"
export * from "./LocationsView.vue?vue&type=script&lang=js"
script.render = render

export default script